import DealerTableFilter from './dealer-table-filter';

export default DealerTableFilter;